import { render, staticRenderFns } from "./HistoryAlarmPage.vue?vue&type=template&id=6b0f1a0e&"
import script from "./HistoryAlarmPage.vue?vue&type=script&lang=js&"
export * from "./HistoryAlarmPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports